import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { isEditor, getPrefixApi } from './utils';

export interface APPImagesResponse {
  primaryColor?: string;
  logoImageUrl?: string;
  coverImagesUrls?: string[];
  showLogoInHeader: boolean;
  headerTitle?: string;
}

export const getAppImages = async (flowApi: PlatformControllerFlowAPI) => {
  const { errorHandler, translations } = flowApi;
  const { t } = translations;
  const { withErrorHandler, getResolvedError} = errorHandler;
  const prefix = getPrefixApi(flowApi);

  const api = isEditor(flowApi) ? '/api' : '';
  
  try {
    return await withErrorHandler(
      async () => {
        const { data } = await flowApi.httpClient.get<APPImagesResponse>(
          `${prefix}/wixapp${api}/v1/businesses/display-options`,
          {
            headers: {
              Authorization: flowApi.controllerConfig.appParams.instance,
            },
          },
        );
        return data;
      },
      {
        errorCodesMap: {
          applicationError: {
            INVALID_INSTANCE: () => ({
              message: "Invalid app instance provided.",
            }),
            UNAUTHORIZED: () => ({
              message: "You are not authorized to access this resource.",
            }),
            NOT_FOUND: () => ({
              message: "App display options not found.",
            }),
          },
          serverError: () => ({
            message: t('download_my_app.widget.serverError'),
          }),
        },
      },
    );
  } catch (error) {
    const resolvedError = getResolvedError(error);
    console.error('Error fetching getAppImages:', resolvedError);
    
    // Fallback for any unexpected errors
    return {
      primaryColor: '',
      logoImageUrl: '',
      coverImagesUrls: [],
      showLogoInHeader: true,
      headerTitle: '',
    };
  }
};
